'use strict';

export default {
  organizationPage: {
    organization: 'Organisation',
    save: 'Sauvegarder',
    picture: 'Choisir photo',
    nameError: 'Le nom ne peut pas être vide',
    empty: ' ',
    selection: {
      title: 'Choisissez votre organisation',
      addOrganization: 'Ajouter une organisation',
      welcome: 'Bonjour ',
      choose: 'Choisissez votre organisation',
      noOrganizations: 'Aucune organisation à afficher',
    },
  },
};
